
export const LayerType = {
    TEXT_LAYER: "TextLayer",
    IMAGE_LAYER: "ImageLayer",
    VIDEO_LAYER: "VideoLayer",
    BUTTON_LAYER: "ButtonLayer",
    ELEMENT_LAYER: "ElementLayer"
}